import { Vue } from 'vue-property-decorator';
import * as Sentry from '@sentry/vue';
import { Catalog } from '@/shared/model/catalogo.model';
import { saciApi } from '@/shared/config/api/saci';
import { MAXIMO_REGISTROS_PAGINACION_SACI } from '@/constants';

export default class CatalogoService extends Vue {
  public catalogoServiceName = {
    getSectoresScian: 'getScianSectores',
    getSubSectorScian: 'getScianDivisionesScianSectores',
    getRamaScian: 'getScianGruposScianDivisiones',
    getSubRamaScian: 'getScianClasesScianGrupos',
    getClaseScian: 'getScianSubclasesScianClases',
    getSectorOcde: 'getOcdeSectores',
    getDivisionOcde: 'getOcdeDivisionesOcdeSector',
    getGrupoOcde: 'getOcdeGruposOcdeDivisiones',
    getClaseOcde: 'getOcdeClasesOcdeGrupos',
  };

  public toCatalogoVue(jsonData: Array<any>): Array<any> {
    const catalogo = [];
    jsonData.forEach(element => {
      catalogo.push({ value: element, text: element.nombre });
    });
    return catalogo;
  }

  public toCatalogoIdValue(jsonData: Array<any>): Array<any> {
    const catalogo = [];
    jsonData.forEach(element => {
      catalogo.push({ value: element.id, text: element.nombre });
    });
    return catalogo;
  }

  public toCatalogo(data: any): any {
    const catalog = new Catalog(data.id, data.nombre);
    return { value: catalog.id, text: catalog.nombre };
  }

  public toCatalogos(data: Array<any>): Array<any> {
    const catalogos = [];
    data.forEach(item => {
      catalogos.push(this.toCatalogo(item));
    });
    return catalogos;
  }

  public getInst(
    catalogo: string,
    instTipoUnoOPais = null,
    instTipoDos = null,
    clvEntidad = null,
    clvMunicipio = null,
    page = 1,
    registros = 300,
    search: string = null
  ): Promise<any[]> {
    const dummy = [];
    switch (catalogo) {
      case 'getClaveCatExtranjeraPais':
      case 'getCveCatNacionalPublico':
        return new Promise((resolve, reject) => {
          saciApi[catalogo](instTipoUnoOPais, page, registros, search)
            .then(res => {
              resolve(Object.assign(res));
            })
            .catch(err => {
              Sentry.captureException(err);
            });
        });

      case 'getCveClaveCatNacionalPublico':
        return new Promise((resolve, reject) => {
          saciApi
            .getCveClaveCatNacionalPublico(instTipoUnoOPais, instTipoDos, page, registros, search)
            .then(res => {
              resolve(Object.assign(res));
            })
            .catch(err => {
              Sentry.captureException(err);
            });
        });

      case 'getsCveClaveCatNacionalPublico':
        return new Promise((resolve, reject) => {
          saciApi
            .getsCveClaveCatNacionalPublico(instTipoUnoOPais, instTipoDos, clvEntidad, page, registros, search)
            .then(res => {
              resolve(Object.assign(res));
            })
            .catch(err => {
              Sentry.captureException(err);
            });
        });

      case 'getClaveCveCatNacionalPublico':
        return new Promise((resolve, reject) => {
          saciApi
            .getClaveCveCatNacionalPublico(instTipoUnoOPais, instTipoDos, clvEntidad, clvMunicipio, page, registros, search)
            .then(res => {
              resolve(Object.assign(res));
            })
            .catch(err => {
              Sentry.captureException(err);
            });
        });
    }
  }

  public pageTotal = 0;

  public getPaginatedService(
    operationId: string,
    search: string = null,
    instTipoUnoOPais = null,
    instTipoDos = null,
    clvEntidad = null,
    clvMunicipio = null,
    page = 1,
    registros = MAXIMO_REGISTROS_PAGINACION_SACI,
    listaInst = {}
  ) {
    return this.getInst(operationId, instTipoUnoOPais, instTipoDos, clvEntidad, clvMunicipio, page, registros, search)
      .then(result => {
        if (result['headers']['x-total-pages'] && this.pageTotal == 0) this.pageTotal = Number(result['headers']['x-total-pages']);
        if (page == 1) {
          listaInst = result['data'];
        } else {
          listaInst = Object.assign(listaInst).concat(result['data']);
        }
        if (page >= this.pageTotal) {
          return this.toCatalogoVue(Object.assign(listaInst));
        }
        page++;
        return this.getPaginatedService(
          operationId,
          search,
          instTipoUnoOPais,
          instTipoDos,
          clvEntidad,
          clvMunicipio,
          page,
          registros,
          listaInst
        );
      })
      .catch(err => {
        Sentry.captureException(err);
      });
  }

  public getCatEjesProgramaticos() {
    return new Promise((resolve, reject) => {
      saciApi
        .getCatEjesProgramaticos()
        .then(res => {
          resolve(this.toCatalogoIdValue(Object.assign(res.data)));
        })
        .catch(err => {
          Sentry.captureException(err);
        });
    });
  }

  //Nuevo Metodo para llamadas de catalogos con paginado, con o sin parametros
  public getCatalogoPaginado(
    catalogo: string,
    extraArgs: any[] = [],
    page = 1,
    registros = MAXIMO_REGISTROS_PAGINACION_SACI,
    listaCompleta: any[] = []
  ): Promise<any[]> {
    const args = [...extraArgs, page, registros];

    return saciApi[catalogo](...args)
      .then(res => {
        if (res?.headers?.['x-total-pages'] && this.pageTotal === 0) {
          this.pageTotal = Number(res.headers['x-total-pages']);
        }

        listaCompleta = page === 1 ? res.data : listaCompleta.concat(res.data);

        if (page >= this.pageTotal) {
          return this.toCatalogoVue(listaCompleta);
        }

        return this.getCatalogoPaginado(catalogo, extraArgs, page + 1, registros, listaCompleta);
      })
      .catch(err => {
        Sentry.captureException(err);
        return [];
      });
  }
}
